var _ = require('../util')
var Watcher = require('../watcher')
var bindingModes = require('../config')._propBindingModes

module.exports = {

  bind: function () {

    var child = this.vm
    var parent = child.$parent
    // passed in from compiler directly
    var prop = this._descriptor
    var childKey = prop.path
    var parentKey = prop.parentPath

    // simple lock to avoid circular updates.
    // without this it would stabilize too, but this makes
    // sure it doesn't cause other watchers to re-evaluate.
    var locked = false

    this.parentWatcher = new Watcher(
      parent,
      parentKey,
      function (val) {
        if (!locked) {
          locked = true
          // all props have been initialized already
          if (_.assertProp(prop, val)) {
            child[childKey] = val
          }
          locked = false
        }
      },
      { sync: true }
    )
    
    // set the child initial value first, before setting
    // up the child watcher to avoid triggering it
    // immediately.
    var value = this.parentWatcher.value
    if (_.assertProp(prop, value)) {
      child.$set(childKey, value)
    }

    // only setup two-way binding if this is not a one-way
    // binding.
    if (prop.mode === bindingModes.TWO_WAY) {
      this.childWatcher = new Watcher(
        child,
        childKey,
        function (val) {
          if (!locked) {
            locked = true
            parent.$set(parentKey, val)
            locked = false
          }
        },
        { sync: true }
      )
    }
  },

  unbind: function () {
    if (this.parentWatcher) {
      this.parentWatcher.teardown()
    }
    if (this.childWatcher) {
      this.childWatcher.teardown()
    }
  }
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/directives/prop.js
 ** module id = 16
 ** module chunks = 0
 **/